<template lang="pug">
span
  v-system-bar(v-if="serviceFeeBarVisible" height="40" app color="warning" :style="ofdBarVisible ? 'top: 40px;' : ''" @click="showDialogFromBar")
    .container.text-center.text-subtitle-2.white--text.re-cursor-pointer {{ $t("перейдите_на_офд_rekassa_или_оплатите_сервисный_сбор", { days: formatDays(daysLeft) }) }}

  v-dialog(v-model="calculatorShow" max-width="375" persistent hide-overlay)
    v-sheet.service-fee-dialog.rounded-xl.pa-6.px-5
      p.sfd-title {{ $t("сервисный_сбор_не_оплачен") }}
      template(v-if="warningMode")
        .sfd-badge
          span.sfd-badge-dot
          span.sfd-badge-text {{ $t("осталось_дней_без_оплаты_касса_будет_заблокирована", { days: formatDays(daysLeft) }) }}
      template(v-else)
        p.sfd-body.text-center {{ $t("вы_сможете_пробивать_чеки_как_только_оплатите_сервисный_сбор") }}

      i18n.sfd-body(path="с_1_июля_для_касс_со_сторонним_офд_действует_сервисный_сбор" tag="p")
        template(v-slot:link)
          a(:href="serviceFeeUrl" @click.prevent="openServiceFeeDetails") {{ $t("сервисный_сбор") }}

      .sfd-offer.d-flex.align-start
        v-icon.sfd-offer-icon.mr-3(size="32") mdi-gift-outline
        .flex-grow-1(style="min-width: 0")
          .sfd-offer-title {{ $t("хотите_не_платить_сервисный_сбор") }}
          .sfd-offer-text {{ offerText }}

      button.sfd-btn.sfd-btn-primary(@click="goToOfdMiniApp") {{ $t("перейти_на_офд_rekassa") }}
      button.sfd-btn.sfd-btn-secondary(@click="goToPayment('from=service_fee_blocked'); analyticsLogEvent({ eventName: 're_billing_calculator_popup_pay_clicked', type: 'service_fee' })") {{ $t("оплатить_1_500") }}
      button.sfd-btn.sfd-btn-tertiary(v-if="warningMode" @click="calculatorPaymentNotifierDialog = false; analyticsLogEvent({ eventName: 're_billing_calculator_popup_later_clicked', type: 'service_fee' })") {{ $t("оплатить_позже") }}

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { getLocale } from '../../i18n'
import { DIALOG_PRIORITIES } from '../../utils/dialogPriorities'

const DIALOG_ID = 'service-fee-payment-notifier'
// Кэш состояния подписки между экземплярами компонента: страницы (Dashboard,
// Calculator) пересоздают компонент при переходах, и без кэша плашка
// появлялась бы заново только после сетевой проверки - дёргание интерфейса
const subscriptionStateCache = {}
const DEFAULT_GRACE_PERIOD_DAYS = 5
const GRACE_PERIOD_STORAGE_KEY = 'rekassa.kz-service-fee-grace-period-days'
// За сколько дней до конца graceful period диалог снова показывается при каждом входе
const ALWAYS_SHOW_DAYS_LEFT = 2

export default {
  props: {
    calculatorMode: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    calculatorPaymentNotifierDialog: false,
    curtainElement: null,

    // TODO: remove
    warningMode: false,
    daysLeft: 0,
    gracePeriodDays: DEFAULT_GRACE_PERIOD_DAYS,
    noSubscription: false,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      firebaseAuth: state => state.auth.firebaseAuth,
    }),

    ...mapGetters('dialogQueue', ['isActive']),

    calculatorShow() {
      return this.calculatorPaymentNotifierDialog && this.isActive(DIALOG_ID)
    },

    serviceFeeLocale() {
      return getLocale() === 'kk' ? 'kz' : 'ru'
    },

    serviceFeeUrl() {
      return `https://rekassa.kz/${this.serviceFeeLocale}/service-fee`
    },

    serviceFeeBarVisible() {
      // Плашку рендерит только экземпляр в NavBar (dashboard-режим),
      // иначе на странице кассы было бы два v-system-bar
      return !this.calculatorMode && this.noSubscription && this.warningMode
    },

    ofdBarVisible() {
      // Условие плашки OFDPaymentNotifier - под ней наша плашка сдвигается вниз
      return this.cashRegister.status === 'REGISTERED'
        && (this.cashRegister.fdoMode === 'OFFLINE' || this.cashRegister.fdoMode === 'BLOCKED')
    },

    offerText() {
      // Акция «июль месяц ОФД бесплатно» действует только в июле 2026
      const now = this.$moment()
      const isJuly2026 = now.year() === 2026 && now.month() === 6
      return isJuly2026
        ? this.$t('перейдите_на_офд_rekassa_тогда_сервисный_сбор_будет_всегда_0_июль')
        : this.$t('перейдите_на_офд_rekassa_тогда_сервисный_сбор_будет_всегда_0')
    },
  },

  watch: {
    'cashRegister.id': {
      handler() {
        this.calculatorPaymentNotifierDialog = false
        this.noSubscription = false
        this.restoreCachedState()
        this.handleServiceFeePaymentStatus()
      },
      deep: true,
    },

    calculatorShow(newVal) {
      if (newVal) {
        this.createCurtain()
      } else {
        this.removeCurtain()
      }
    },

    calculatorPaymentNotifierDialog(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.releaseDialog(DIALOG_ID)
      }
    },
  },

  created() {
    this.restoreCachedState()
    this.handleServiceFeePaymentStatus()
  },

  beforeDestroy() {
    this.removeCurtain()

    const allCurtains = document.querySelectorAll('.re-service-fee-payment-notifier-curtain')
    allCurtains.forEach(curtain => {
      curtain.remove()
    })

    this.releaseDialog(DIALOG_ID)
  },

  methods: {
    ...mapActions({
      fetchSubscriptionStatus: 'miniapp/fetchSubscriptionStatus',
      analyticsLogEvent: 'analytics/logEvent',
      showConfirm: 'confirm/showConfirm',
      requestDialog: 'dialogQueue/request',
      releaseDialog: 'dialogQueue/release',
      firebaseRemoteConfigGetString: 'tools/firebaseRemoteConfigGetString',
    }),

    handleServiceFeePaymentStatus() {
      if (this.cashRegister.status === 'REGISTERED') {
        // TODO: remove after successful release
        // SERVICE_FEE_CONFIG: {"enabled": true, "gracePeriodDays": 5}
        this.firebaseRemoteConfigGetString('SERVICE_FEE_CONFIG').then((result) => {
          const config = JSON.parse(result)
          this.gracePeriodDays = this.resolveGracePeriodDays(config.gracePeriodDays)
          if (config.enabled === true) {
            this.checkServiceFeePaymentStatus()
          }
        }).catch(() => {})
      }
    },

    // gracePeriodDays храним локально и перезатираем, только когда значение из
    // Remote Config выросло: уменьшение конфига не должно внезапно блокировать
    // кассы, которым уже пообещали более длинный graceful period
    resolveGracePeriodDays(remoteValue) {
      // gracePeriodDays: 0 - допустимое значение (блокировка сразу, без warningMode)
      const remoteParsed = parseInt(remoteValue, 10)
      const remote = Number.isNaN(remoteParsed) ? null : Math.max(0, remoteParsed)
      const storedParsed = parseInt(localStorage.getItem(GRACE_PERIOD_STORAGE_KEY), 10)
      const stored = Number.isNaN(storedParsed) ? null : storedParsed

      if (remote === null) {
        return stored !== null ? stored : DEFAULT_GRACE_PERIOD_DAYS
      }
      if (stored === null || remote > stored) {
        localStorage.setItem(GRACE_PERIOD_STORAGE_KEY, String(remote))
        return remote
      }
      return stored
    },

    checkServiceFeePaymentStatus() {
      if (this.calculatorMode) {
        this.checkCalculatorModePayment()
      } else {
        this.checkDashboardModePayment()
      }
    },

    // Восстанавливает закэшированное состояние, чтобы плашка отрисовалась сразу,
    // не дожидаясь сетевой проверки (актуальное состояние обновит её результат)
    restoreCachedState() {
      const cached = subscriptionStateCache[this.cashRegister.id]
      if (!cached) {
        return
      }
      this.gracePeriodDays = cached.gracePeriodDays
      this.noSubscription = cached.noSubscription
      if (this.noSubscription) {
        this.computeGracePeriod()
      }
    },

    cacheSubscriptionState(noSubscription) {
      this.noSubscription = noSubscription
      subscriptionStateCache[this.cashRegister.id] = {
        noSubscription,
        gracePeriodDays: this.gracePeriodDays,
      }
    },

    async checkCalculatorModePayment() {
      try {
        await this.fetchSubscriptionStatus(this.cashRegister.serialNumber)
        this.cacheSubscriptionState(false)
      } catch (error) {
        if (error?.response?.status === 404 && error?.response?.data?.errorCode === 'SUBSCRIPTION_NOT_FOUND') {
          this.cacheSubscriptionState(true)
          this.showCalculatorPaymentNotifier()
        }
      }
    },

    async checkDashboardModePayment() {
      try {
        const result = await this.fetchSubscriptionStatus(this.cashRegister.serialNumber)
        console.debug('Service Fee Subscription status: ', result.data)
        this.cacheSubscriptionState(false)

        if (result?.data?.currentBillingPeriodEndingAt) {
          const hoursLeft = this.$moment(result.data.currentBillingPeriodEndingAt).diff(this.$moment(), 'hours')
          const daysLeft = Math.ceil(hoursLeft / 24)
          console.debug('Service Fee Days left: ', daysLeft)

          // Если осталось меньше 5 дней, то показываем уведомление один раз
          if (daysLeft <= 5 && daysLeft > 0 && !result?.data?.code?.includes('free')) {
            this.showPaymentNotifier(this.$moment().format('YYYY-MM'))
          }
        }
      } catch (error) {
        if (error?.response?.status === 404 && error?.response?.data?.errorCode === 'SUBSCRIPTION_NOT_FOUND') {
          // Подписки нет - считаем graceful period, чтобы показать плашку
          this.cacheSubscriptionState(true)
          this.computeGracePeriod()
        }
      }
    },

    /// //////////////////////////////////////////////////////////////////////////////
    formatDays(days) {
      if (getLocale() === 'kk') {
        return `${days} күн`
      }

      const lastDigit = days % 10
      const lastTwoDigits = days % 100

      if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return `${days} дней`
      }

      if (lastDigit === 1) {
        return `${days} день`
      }

      if (lastDigit >= 2 && lastDigit <= 4) {
        return `${days} дня`
      }

      return `${days} дней`
    },

    computeGracePeriod() {
      // Проверка условий для warningMode
      const now = this.$moment()

      // Сервисный сбор ежемесячный, поэтому ключ уникален для каждого месяца -
      // с нового месяца graceful period отсчитывается заново
      const yearMonth = now.format('YYYY-MM')
      const storageKey = `rekassa.kz-cashRegister-${this.cashRegister.id}-date-${yearMonth}-warning-mode-start-date-service-fee`
      let startDate = localStorage.getItem(storageKey)

      if (!startDate) {
        // Первый вызов - сохраняем текущую дату
        startDate = now.format('YYYY-MM-DD')
        localStorage.setItem(storageKey, startDate)
      }

      // Вычисляем количество дней до окончания graceful period.
      // Храним только дату старта: при изменении gracePeriodDays в Remote Config
      // срок пересчитывается автоматически (в т.ч. разблокировка при увеличении)
      const startMoment = this.$moment(startDate).startOf('day')
      const endMoment = startMoment.clone().add(this.gracePeriodDays, 'days').startOf('day') // До 00:00 следующего дня
      const currentMoment = now.startOf('day')

      this.daysLeft = endMoment.diff(currentMoment, 'days')

      // Если graceful period ещё не истёк (до 00:00), включаем warningMode
      this.warningMode = this.daysLeft > 0
      /// //////////////////////////////////////////////////////////////////////////////
    },

    showCalculatorPaymentNotifier() {
      this.computeGracePeriod()

      // Показываем один раз за вход, кроме последних дней graceful period
      // и режима блокировки (daysLeft <= 0) - тогда при каждом входе
      const yearMonth = this.$moment().format('YYYY-MM')
      const sessionKey = `rekassa.kz-cashRegister-${this.cashRegister.id}-date-${yearMonth}-service-fee-notifier-shown`
      if (this.daysLeft > ALWAYS_SHOW_DAYS_LEFT && sessionStorage.getItem(sessionKey) === 'true') {
        return
      }
      sessionStorage.setItem(sessionKey, 'true')

      this.calculatorPaymentNotifierDialog = true
      this.requestDialog({ id: DIALOG_ID, priority: DIALOG_PRIORITIES.CALCULATOR_BLOCK })
      this.analyticsLogEvent({ eventName: 're_billing_calculator_popup_shown', type: 'service_fee' })
    },

    showDialogFromBar() {
      // Диалог уже открыт (например, экземпляром в режиме калькулятора)
      if (this.isActive(DIALOG_ID)) {
        return
      }
      this.analyticsLogEvent({ eventName: 're_billing_service_fee_bar_clicked', type: 'service_fee' })
      this.calculatorPaymentNotifierDialog = true
      this.requestDialog({ id: DIALOG_ID, priority: DIALOG_PRIORITIES.CALCULATOR_BLOCK })
    },

    createCurtain() {
      this.$nextTick(() => {
        const existingCurtains = document.querySelectorAll('.re-service-fee-payment-notifier-curtain')
        existingCurtains.forEach(curtain => curtain.remove())

        const curtain = document.createElement('div')
        curtain.classList.add('re-service-fee-payment-notifier-curtain')
        curtain.style.position = 'fixed'
        curtain.style.top = '0'
        curtain.style.left = '0'
        curtain.style.width = '100%'
        curtain.style.height = '100%'
        curtain.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'

        this.curtainElement = curtain

        const mainWrap = document.querySelector('.v-main__wrap')
        if (mainWrap) {
          mainWrap.appendChild(curtain)
        } else {
          document.body.appendChild(curtain)
        }
      })
    },

    removeCurtain() {
      if (this.curtainElement && this.curtainElement.parentNode) {
        this.curtainElement.remove()
      }
      this.curtainElement = null
    },

    showPaymentNotifier(date) {
      const name = `rekassa.kz-cashRegister-${this.cashRegister.id}-date-${date}-payment-notifier-seen`
      const paymentNotifierSeen = (localStorage.getItem(name) || 'false') === 'true'
      if (paymentNotifierSeen) {
        return
      }

      this.analyticsLogEvent({ eventName: 're_billing_main_popup_shown', type: 'service_fee' })

      this.showConfirm({
        title: this.$t('не_забудьте_оплатить_сервисный_сбор'),
        icon: 'mdi-alert-circle-outline',
        text: this.$t('без_оплаты_вы_не_сможете_пробивать_чеки_оплатите_сейчас_в_разделе_мои_подписки'),
        resolveText: this.$t('перейти_к_оплате'),
        rejectText: this.$t('оплатить_позже'),
        persistent: true,
        priority: DIALOG_PRIORITIES.PAYMENT_REMINDER,
      }).then(() => {
        this.analyticsLogEvent({ eventName: 're_billing_main_popup_clicked', type: 'service_fee' })
        this.goToPayment()
      }).catch(() => {})

      localStorage.setItem(name, 'true')
    },

    goToPayment(params) {
      this.calculatorPaymentNotifierDialog = false
      this.$router.push(`/miniapp?name=account&serialNumber=${this.cashRegister.serialNumber}${params ? `&${params}` : ''}`)
    },

    goToOfdMiniApp() {
      this.analyticsLogEvent({ eventName: 're_billing_calculator_popup_switch_ofd_clicked', type: 'service_fee' })
      this.calculatorPaymentNotifierDialog = false
      this.$router.push('/miniapp?name=ofd')
    },

    openServiceFeeDetails() {
      this.analyticsLogEvent({ eventName: 're_billing_calculator_popup_details_clicked', type: 'service_fee' })
      this.$openLink(this.serviceFeeUrl, '_system')
    },
  },
}
</script>

<style scoped>
/* Палитра макета dialog-1b: светлая поверхность независимо от темы приложения */
.service-fee-dialog {
  background: #F7FAF9 !important;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.sfd-title {
  font-size: 22px;
  font-weight: 700;
  color: #0E2622;
  text-align: center;
  line-height: 1.25;
  margin-bottom: 0;
}
.sfd-badge {
  align-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #FFF4E0;
  border: 1px solid #F5D08C;
  border-radius: 10px;
  padding: 6px 14px;
  width: fit-content;
}
.sfd-badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #E8930C;
  flex-shrink: 0;
}
.sfd-badge-text {
  font-size: 13px;
  font-weight: 600;
  color: #9A5B00;
}
.sfd-body {
  font-size: 15px;
  line-height: 1.55;
  color: #3E524D;
  margin-bottom: 0;
}
.sfd-body a {
  color: #0E8F6F;
  text-decoration: underline;
  text-decoration-color: rgba(14, 143, 111, 0.4);
  text-underline-offset: 3px;
}
.sfd-offer {
  background: #E9F6F1;
  border: 1px solid #C4E7DB;
  border-radius: 14px;
  padding: 16px;
}
.sfd-offer-icon {
  color: #0E8F6F !important;
}
.sfd-offer-title {
  font-size: 15px;
  font-weight: 700;
  color: #0E2622;
  margin-bottom: 6px;
}
.sfd-offer-text {
  font-size: 14px;
  line-height: 1.5;
  color: #33544C;
}
.sfd-btn {
  font-family: inherit;
  font-size: 16px;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
  width: 100%;
}
.sfd-btn-primary {
  background: #0E8F6F;
  color: #FFFFFF;
  font-weight: 700;
  border: none;
  padding: 15px;
}
.sfd-btn-secondary {
  background: transparent;
  border: 1px solid #C6CFCC;
  color: #0E2622;
  font-weight: 600;
  padding: 14px;
  margin-top: -6px;
}
.sfd-btn-tertiary {
  background: none;
  border: none;
  color: #7B8783;
  font-size: 15px;
  padding: 8px;
  margin-top: -8px;
}
</style>

<style>
/* Светлая поверхность диалога: глобальная рамка тёмной темы на ней не нужна,
   а фон макета #F7FAF9 не должен перебиваться белым из main.styl */
.v-dialog > .service-fee-dialog.v-sheet {
  border: none !important;
  background: #F7FAF9 !important;
}
</style>
